module.exports = __webpack_public_path__ + "media/member-joined.bd163314.mp3";